import React from "react";
import { dialog, InputJson } from "../../../../../nq-component";
import {
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import BaseFormPage from "../../../../../base/BaseFormPage";
import NavBar from "../../../../../components/navbar";
import FormFactory from "../../../../../components/FormFactory";
import ProductPickerField from "../../../../../components/ProductPicker";
import DialogModal from "../../../../../components/Dialog";
import WasteComponentFormPresenter from "./WasteComponentFormPresenter";
import ComponentPickerField from "../../../../../components/ComponentPicker";

class WasteComponentFormPage extends BaseFormPage {
  constructor(props) {
    super(props);

    this.state = {
      object: { items: [] }, // ✅ important
      advanced: false,
    };

    this.presenter = new WasteComponentFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "waste_records_manual";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    // ✅ always keep items array
    const safe = {
      ...(object || {}),
      items: Array.isArray(object?.items) ? object.items : [],
    };

    this.setState({ object: safe });
    this.presenter.onChangeObject(safe);
  }

  // ✅ Add More button handler
  addMoreItem() {
    const object = this.state.object || {};
    const items = Array.isArray(object.items) ? [...object.items] : [];

    items.push({
      product: null,
      itemName: "",
      sku: "",
      cost: null,
      quantity: 1,
      description: "",
    });

    this.onChangeObject({ ...object, items });
  }

  // ✅ update specific item row
  updateItem(index, nextItem) {
    const object = this.state.object || {};
    const items = Array.isArray(object.items) ? [...object.items] : [];

    items[index] = { ...(nextItem || {}) };
    this.onChangeObject({ ...object, items });
  }

  // ✅ remove row
  removeItem(index) {
    const object = this.state.object || {};
    const items = Array.isArray(object.items) ? [...object.items] : [];

    items.splice(index, 1);
    this.onChangeObject({ ...object, items });
  }

  onSubmitForm(e) {
    e.preventDefault();
    // this.presenter.submit();
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit(false)}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  render() {
    const object = this.state.object || { items: [] };
    const advanced = this.state.advanced;

    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;

    const label = this.getObjectId() === undefined ? "Add New " : "View ";

    const items = Array.isArray(object.items) ? object.items : [];

    return (
      <>
        <NavBar
          action={() => (
            <div className="dropdown dropstart d-inline-block">
              <i
                role="button"
                data-bs-toggle="dropdown"
                className="bi bi-three-dots-vertical"
              ></i>
              <div className="dropdown-menu fs-xs">
                <button
                  type="button"
                  onClick={this.onClickAdvance.bind(this)}
                  className="dropdown-item py-3"
                >
                  <i className="bi bi-gear pe-2" />
                  Toggle Advance
                </button>
              </div>
            </div>
          )}
        />

        <div className="overflow-auto" style={{ background: "#F9FAFB", minHeight: "100vh" }}>
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div style={{ 
                background: "linear-gradient(135deg, #83c14a 0%, #6fa83e 100%)", 
                borderRadius: "16px", 
                padding: "24px 28px",
                boxShadow: "0 4px 20px rgba(131, 193, 74, 0.2)",
                marginBottom: "24px",
                marginTop: "16px"
              }}>
                <div className="d-flex align-items-center gap-3">
                  <div style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    background: "rgba(255, 255, 255, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backdropFilter: "blur(10px)"
                  }}>
                    <i className="bi bi-box-seam" style={{ fontSize: "1.5rem", color: "#fff" }}></i>
                  </div>
                  <div>
                    <h1 className="fw-bold mb-1 text-white" style={{ fontSize: "1.75rem", letterSpacing: "-0.5px" }}>
                      {label + "Waste Components"}
                    </h1>
                    <p className="mb-0 text-white" style={{ opacity: 0.9, fontSize: "0.9375rem" }}>
                      Manage and track waste component records
                    </p>
                  </div>
                </div>
              </div>

              <div style={{
                background: "#fff",
                borderRadius: "16px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.05)",
                padding: "28px 32px"
              }}>
                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        {items.length === 0 ? (
                          <div className="col-12">
                            <div style={{
                              background: "linear-gradient(135deg, #EBF5FF 0%, #F0F9FF 100%)",
                              border: "2px dashed #93C5FD",
                              borderRadius: "12px",
                              padding: "48px 24px",
                              textAlign: "center"
                            }}>
                              <div style={{
                                width: "64px",
                                height: "64px",
                                borderRadius: "50%",
                                background: "rgba(59, 130, 246, 0.1)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "0 auto 16px"
                              }}>
                                <i className="bi bi-inbox" style={{ fontSize: "2rem", color: "#3B82F6" }}></i>
                              </div>
                              <h5 className="fw-bold mb-2" style={{ color: "#1F2937" }}>No Items Added Yet</h5>
                              <p className="text-muted mb-0" style={{ fontSize: "0.9375rem" }}>
                                Click <strong style={{ color: "#83c14a" }}>Add More</strong> button below to add waste components
                              </p>
                            </div>
                          </div>
                        ) : (
                          items.map((item, idx) => (
                            <div key={idx} className="col-12">
                              <div style={{
                                background: "#fff",
                                border: "2px solid #E5E7EB",
                                borderRadius: "12px",
                                padding: "20px",
                                transition: "all 0.3s ease"
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = "#83c14a";
                                e.currentTarget.style.boxShadow = "0 4px 12px rgba(131, 193, 74, 0.15)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = "#E5E7EB";
                                e.currentTarget.style.boxShadow = "none";
                              }}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <div className="d-flex align-items-center gap-2">
                                    <div style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "8px",
                                      background: "linear-gradient(135deg, #83c14a 0%, #6fa83e 100%)",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "#fff",
                                      fontSize: "0.875rem",
                                      fontWeight: "700"
                                    }}>
                                      {idx + 1}
                                    </div>
                                    <span className="fw-bold" style={{ fontSize: "1rem", color: "#111827" }}>
                                      Item #{idx + 1}
                                    </span>
                                  </div>

                                  <button
                                    type="button"
                                    className="btn btn-sm"
                                    style={{
                                      background: "linear-gradient(135deg, #EF4444 0%, #DC2626 100%)",
                                      border: "none",
                                      color: "#fff",
                                      padding: "6px 14px",
                                      borderRadius: "8px",
                                      fontSize: "0.8125rem",
                                      fontWeight: "600",
                                      boxShadow: "0 2px 8px rgba(239, 68, 68, 0.2)",
                                      transition: "all 0.3s ease"
                                    }}
                                    onClick={() => this.removeItem(idx)}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.transform = "translateY(-2px)";
                                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(239, 68, 68, 0.3)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.transform = "translateY(0)";
                                      e.currentTarget.style.boxShadow = "0 2px 8px rgba(239, 68, 68, 0.2)";
                                    }}
                                  >
                                    <i className="bi bi-trash me-2"></i>Remove
                                  </button>
                                </div>

                                <ComponentPickerField
                                  object={item}
                                  onChangeObject={(nextItem) =>
                                    this.updateItem(idx, nextItem)
                                  }
                                />
                              </div>
                            </div>
                          ))
                        )}
                      </>
                    )}
                  </div>

                  <div style={{
                    marginTop: "32px",
                    paddingTop: "24px",
                    borderTop: "2px solid #F3F4F6",
                    display: "flex",
                    gap: "12px",
                    flexWrap: "wrap"
                  }}>
                    <button
                      type="submit"
                      className="btn"
                      style={{
                        background: "linear-gradient(135deg, #83c14a 0%, #6fa83e 100%)",
                        border: "none",
                        color: "#fff",
                        padding: "12px 24px",
                        borderRadius: "10px",
                        fontSize: "0.9375rem",
                        fontWeight: "600",
                        boxShadow: "0 4px 12px rgba(131, 193, 74, 0.3)",
                        transition: "all 0.3s ease"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 6px 20px rgba(131, 193, 74, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(131, 193, 74, 0.3)";
                      }}
                    >
                      <i className="bi bi-check-circle me-2"></i>Save Changes
                    </button>

                    <button
                      type="button"
                      className="btn"
                      style={{
                        background: "#fff",
                        border: "2px solid #E5E7EB",
                        color: "#374151",
                        padding: "12px 24px",
                        borderRadius: "10px",
                        fontSize: "0.9375rem",
                        fontWeight: "600",
                        transition: "all 0.3s ease"
                      }}
                      onClick={this.onClickBack.bind(this)}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = "#F9FAFB";
                        e.currentTarget.style.borderColor = "#D1D5DB";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "#fff";
                        e.currentTarget.style.borderColor = "#E5E7EB";
                      }}
                    >
                      <i className="bi bi-arrow-left me-2"></i>Go Back
                    </button>

                    <button
                      type="button"
                      className="btn"
                      style={{
                        background: "linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)",
                        border: "none",
                        color: "#fff",
                        padding: "12px 24px",
                        borderRadius: "10px",
                        fontSize: "0.9375rem",
                        fontWeight: "600",
                        boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",
                        transition: "all 0.3s ease"
                      }}
                      onClick={this.addMoreItem.bind(this)}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 6px 20px rgba(59, 130, 246, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(59, 130, 246, 0.3)";
                      }}
                    >
                      <i className="bi bi-plus-circle me-2"></i>Add More
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(WasteComponentFormPage);
